import Environment from '@di-shared/features/environment/Environment';
import Kr from '@di-shared/features/history/driving-info/DrivingInfoAdas/.kr';

export interface DrivingInfoAdasProps {
  vin: string;
  selectedDate: Date;
}

export default function DrivingInfoAdas({vin, selectedDate}: DrivingInfoAdasProps) {
  return (
    <>
      <Environment.Kr>
        <Kr
          vin={vin}
          selectedDate={selectedDate}
        />
      </Environment.Kr>
    </>
  );
}
